<template>
    <div class="rcclPopover" id="rcclConfirm" :style="show()">
        <div class="yellowTip-m">
            <div class="yellowTip-title">{{title}}</div>
            <div class="yellowTip-txt" v-html="text"></div>
            <div class="yellowTip-btn js-popupClose" data-popupname="rcclConfirm" @click="cancelClick">{{buttons[0]}}</div>
            <div class="yellowTip-btn js-popupOK" data-popupname="rcclConfirm" @click="confirmClick">{{buttons[1]}}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RcclConfirm',
    data () {
        return  {
            title: '温馨提示',
            text: '',
            buttons: ['取消', '确定'],
            isShow: false
        }
    },
    confirmCallBack () {
    },
    cancelCallBack () {

    },
    methods: {
        confirmClick () {
            this.isShow = false
            if (this.confirmCallBack) {
                this.confirmCallBack()
            }
        },
        cancelClick() {
            this.isShow = false
            if (this.cancelCallBack) {
                this.cancelCallBack()
            }
        },
        show() {
            return this.isShow ? { 'display': 'block'} : { 'display': 'none' }
        }
    }
}
</script>